module.exports = __webpack_public_path__ + "media/video.0dcd4291.mp4";